import type { CSSProperties, ReactNode } from 'react';

interface RowProps {
  /**
   * CSS Grid `grid-template-columns` value. Derived by SurfaceRenderer from
   * children's catalog category + per-child weight/width hints (see
   * `deriveTracks` in `../../components/surface/layout-template.ts`).
   *
   * When empty/missing, falls back to a single `auto` track so the container
   * is renderable in isolation (e.g., Storybook, unit tests).
   */
  template?: string;
  align?: string;
  justify?: string;
  gap?: number;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

export function RowView({ template, align, justify, gap, className, style, children }: RowProps) {
  return (
    <div
      className={className}
      style={{
        // User-supplied style spreads FIRST so the grid-defining props
        // below cannot be overridden by an agent's accidental display: 'block'.
        ...style,
        display: 'grid',
        gridTemplateColumns: template && template.length > 0 ? template : 'auto',
        gridTemplateRows: 'minmax(0, 1fr)',
        alignItems: align ?? 'stretch',
        justifyContent: justify ?? 'start',
        gap: `${gap ?? 8}px`,
        width: '100%',
      }}
    >
      {children}
    </div>
  );
}
